<template>
    <div v-if="model.app.id && model.currentUser" class="ps-4 pt-4 container-height">

        <div class="d-flex">

            <div>
                <h3>Collaborators</h3>
            </div>

            <div class="dropdown mx-3">
                <button class="btn btn-sm btn-primary me-2 dropdown-toggle" type="button"
                        id="dropdownMenuButton" data-bs-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                    invite collaborator
                </button>

                <div class="dropdown-menu" style="width: 150%; margin-right: 40%;">
                    <form class="px-4 py-3">
                        <div class="mb-3">
                            <input type="email" class="form-control" v-model="invite.email" id="collaboratorEmail"
                                   placeholder="email@example.com">
                        </div>

                        <button type="submit" class="btn btn-primary" @click.prevent="onInviteClick">Invite</button>
                    </form>

                </div>
            </div>

        </div>



        <div v-for="collaborator in model.app.collaborators">
            {{collaborator.name}}
        </div>

        <div class="my-4">
            <h3>Invitations</h3>

            <div v-if="openInvitations.length > 0">
                <div v-for="invitation in openInvitations">
                    {{invitation.email}}
                </div>
            </div>
            <div v-else>
                No open invitations.
            </div>
        </div>

        <hr>

        <div v-if="isOwner">
            <h3>Permissions</h3>

            <div class="row my-2">
                <div class="col-sm-4 col-md-2"><strong>Name</strong></div>
                <div class="col-sm-4 col-md-2"><strong>App Permission</strong></div>
                <div class="col-sm-4 col-md-2"><strong>Data Permission</strong></div>
            </div>

            <div v-for="collaborator in model.app.collaborators" class="row my-1">

                <div class="col-sm-4 col-md-2 mb-1">
                    {{collaborator.name}}
                </div>

                <div class="col-sm-4 col-md-2 mb-1">
                    <select class="form-select" v-model="collaborator.app_permission_id" @change="onPermissionSelected(collaborator)">
                        <option v-for="permission in appPermissions" :value="permission.id">{{permission.permission}}</option>
                    </select>
                </div>

                <div class="col-sm-4 col-md-2 mb-1">
                    <select class="form-select" v-model="collaborator.data_permission_id" @change="onPermissionSelected(collaborator)">
                        <option v-for="permission in dataPermissions" :value="permission.id">{{permissionLabel(permission)}}</option>
                    </select>
                </div>

            </div>
            
        </div>

        <hr>

    </div>
</template>

<script>
    import AppService from "../../services/AppService";
    import CollaboratorService from "../../services/CollaboratorService";

    export default {
        name: 'Collaborators',
        data() {
            return {
                model: webase.model,
                service: new AppService(),
                invite: {
                    email: ''
                }
            }
        },
        computed: {
            openInvitations() {
                return this.model.app.invitations.filter((invitation) => {

                    for (let i = 0; i < this.model.app.collaborators.length; i++) {
                        if (this.model.app.collaborators[i].email === invitation.email) {
                            return false
                        }
                    }

                    return true
                })
            },
            currentUserRole() {
                return webase.managers.permission.currentUserRole()
            },
            isOwner() {
                return this.currentUserRole && this.currentUserRole === 'owner'
            },
            appPermissions() {
                return webase.managers.permission.appPermissions()
            },
            dataPermissions() {
                return webase.managers.permission.dataPermissions()
            },
            slackUrl() {
                let url = 'https://slack.com/oauth/v2/authorize?client_id=13068172832.919176894997&scope=incoming-webhook,channels:read'
                return url + '&app_id=' + this.model.app.id
            },
            isAdmin() {
                return this.model.currentUser && webase.utils.user.isAdmin()
            }
        },
        mounted() {

            if(!this.model.app.id) {
                let appId = this.$route.params.id

                this.service.initApp(appId).then((response) => {
                    console.log('App initialized')
                }).catch((message) => {
                    console.log('error loading app')
                    console.log(message)
                })
            }
        },
        methods: {
            onSaveClick() {
                let request = {
                    app: this.model.app
                }

                this.service.update(this.model.app.id, request).then((response) => {
                    this.app = response
                    // TODO: need to tell user this is complete
                }).catch((message) => {
                    console.log('error saving app')
                    console.log(message)
                })
            },

            onPermissionSelected(collaborator) {
                let service = new CollaboratorService()

                let request = {
                    collaborator: collaborator
                }

                service.update(collaborator.id, request).then((response) => {
                    console.log('Collaborator updated')
                    console.log(response)
                }).catch((message) => {
                    console.log('error saving app')
                    console.log(message)
                })
            },
            onInviteClick() {
                let appService = new AppService();
                let site = window.location.hostname
                appService.inviteUserToCollaborate(this.invite.email, this.model.app.id, site).then((response) => {
                    $('#dropdownMenuButton').dropdown('toggle')
                    //this.messageUtil.success('Invitation sent.')
                    this.invite.email = ''
                }).catch((error) => {
                    //this.messageUtil.error('Error sending invitation, message: ' + error)
                })
            },

            permissionLabel(permission) {
                if(permission && permission.permission === 'VEUO') {
                    return 'view and edit user only'
                }

                return permission.permission
            }
        }
    }
</script>

<style>

</style>
